import makeKey from '../makeKey'

const canonicalName = makeKey

const defaultColourName = 'Default'

// TODO: actually, all these data manipulation things (ones throughout the code) should be in a common place

const getLeadImages = ({ images }) => {
	// Get lead image in useful sizes
	const leadImages = {}
	if (images) {
		Object.keys(images).forEach((imgKey) => {
			const img = images[imgKey]
			if (!leadImages.twentieth && img.type === 'twentieth') {
				leadImages.twentieth = img
			}
			if (!leadImages.quarter && img.type === 'quarter') {
				leadImages.quarter = img
			}
			if (!leadImages.half && img.type === 'half') {
				leadImages.half = img
			}
		})
	}
	return leadImages
}

export default {
	canonicalName,
	getLeadImages,
	defaultColourName
}



// WEBPACK FOOTER //
// ./src/utilities/Data/Colour/index.js